<script>
import oil0 from '@assets/images/oil-icon/oil-0-percent.svg'
import oil20 from '@assets/images/oil-icon/oil-20-percent.svg'
import oil50 from '@assets/images/oil-icon/oil-50-percent.svg'
import oil75 from '@assets/images/oil-icon/oil-75-percent.svg'
import oil100 from '@assets/images/oil-icon/oil-100-percent.svg'

export default {
  name: 'OilLevelIcon',
  components: {
    oil0,
    oil20,
    oil50,
    oil75,
    oil100,
  },
  props: {
    level: {
      type: [Number, String],
      default: '',
    },
    currentVolume: {
      type: [Number, String],
      default: '',
    },
  },
  computed: {
    getCurrentOilValue() {
      return parseFloat((this.currentVolume / 1000).toFixed(2))
    },
    name() {
      if (+this.level <= 20 && +this.level >= 0) {
        return 'oil0'
      }
      if (+this.level <= 50 && +this.level > 20) {
        return 'oil50'
      }
      if (+this.level <= 75 && +this.level > 50) {
        return 'oil75'
      }
      if (+this.level <= 100 && +this.level > 75) {
        return 'oil100'
      }
    },
  },
}
</script>
<template>
  <div
    v-if="currentVolume || currentVolume === 0"
    class="oilLevelBox">
    <div
      v-tooltip="'' + getCurrentOilValue + ' ' + $t('label__liters')"
      v-if="level || level === 0"
      class="oilIcon">
      <component
        :is="name"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.oilIcon > * {
  width: 24px;
  height: auto;
}

.oilLevelBox {
  text-align: center;
}
</style>
